import {HttpRequest} from "../utils/httpRequest";

let Invite = {
    /**
     * 获取数据列表
     * @param params
     * @returns {*}
     */
    getInviteList(params) {
        return HttpRequest.getRequest({
            url: '/edu/invite/list',
            method: 'get',
            data: params
        });
    },
    /**
     * 所有数据
     * @returns {*}
     */
    getInvites() {
        return HttpRequest.getRequest({
            url: '/edu/invite/all',
            method: 'get'
        });
    },
    /**
     * 根据id查看信息
     * @param id
     * @returns {*}
     */
    getInviteInfo(id) {
        return HttpRequest.getRequest({
            url: '/edu/invite/info/' + id,
            method: 'get'
        });
    },
    /**
     * 添加或编辑数据
     * @param type
     * @param datas
     * @returns {*}
     */
    addOrUpdateInvite(type, datas) {
        return HttpRequest.getRequest({
            url: '/edu/invite/' + type,
            method: 'post',
            data: datas
        });
    },
    /**
     * 删除数据
     * @param params
     * @returns {*}
     */
    deleteInvite(params) {
        return HttpRequest.getRequest({
            url: '/edu/invite/delete',
            method: 'get',
            data: params
        });
    }

};
export {Invite}
